import { startOfTomorrow } from './dates.ts';
import type { TaskFilter, TaskSort, TaskStatus } from '@shared/types';

/**
 * The filters behind each named view, defined once.
 *
 * The sidebar badge and the list itself both call these, so a count can never
 * disagree with the list it labels.
 */

/** Everything still on your plate. */
export const OPEN_STATUSES: TaskStatus[] = ['inbox', 'todo', 'in_progress', 'blocked'];

/**
 * Today = overdue plus due-today, still open.
 *
 * Overdue items are deliberately included rather than given their own section:
 * a deadline you already missed is the most urgent thing you own, and burying
 * it under a separate heading is how it stays missed.
 */
export function todayFilter(now: Date = new Date()): TaskFilter {
  return {
    status: OPEN_STATUSES,
    due_before: startOfTomorrow(now).toISOString(),
    top_level_only: true,
  };
}

export const todaySort: TaskSort[] = [
  { field: 'due_at', dir: 'asc' },
  { field: 'priority', dir: 'desc' },
];

/** Upcoming = everything with a future due date, nearest first. */
export function upcomingFilter(now: Date = new Date()): TaskFilter {
  return {
    status: OPEN_STATUSES,
    due_after: startOfTomorrow(now).toISOString(),
    top_level_only: true,
  };
}

export const upcomingSort: TaskSort[] = [{ field: 'due_at', dir: 'asc' }];

/** Inbox = captured but not yet triaged. */
export function inboxFilter(): TaskFilter {
  return { status: ['inbox'], top_level_only: true };
}

export function projectFilter(projectId: string): TaskFilter {
  return { project_id: [projectId], top_level_only: true };
}

export function allOpenFilter(): TaskFilter {
  return { status: OPEN_STATUSES, top_level_only: true };
}

export const defaultSort: TaskSort[] = [
  { field: 'priority', dir: 'desc' },
  { field: 'due_at', dir: 'asc' },
];
